import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from "react-router";
import { InputGroup, FormControl, Container, Button, Dropdown, Nav, Col, Row, Badge, OverlayTrigger, Tooltip, ButtonGroup, ToastContainer, Spinner } from 'react-bootstrap';

import { ProformaService } from '../../services/ProformaService';
import { EditionService } from '../../services/EditionService';

import DynamicTable from '../../components/table/dynamic-table/DynamicTable';
import Pagination from '../../components/pagination/Pagination';
import SideDetails from '../../components/side-details/SideDetails';
import ProformaDetails from '../../components/side-details/proforma/proforma-details/ProformaDetails';
//import ProformaEdition from '../../components/side-details/proforma/proforma-edition/ProformaEdition';
import ColManager from '../../components/table/dynamic-table/col-manager/ColManager';
import Families from '../../components/families/Families';
import './Proformas.scss';
import { PreferenceService } from '../../services/PreferenceService';
import ConfirmDialog from '../../components/confirm-dialog/ConfirmDialog';
import ErrorManager from "../../components/error-manager/ErrorManager";
import SendMailDialog from "../../components/send-mail-dialog/SendMailDialog";
import Brouillons from "../../components/brouillons/Brouillons";
import { GlobalContext } from "../../services/GlobalProvider";
import { formatTableHeadersFromPrefs, granted, getFile, currencyFormat, formattedDateInput } from '../../helper/Helper'
import TagsFilter from "../../components/tags-filter/TagsFilter";


const Proformas = () => {

  const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);

  let proformasParams = useRef({
    'start': 0,
    'limit': null,
    'search': null,
    'filters': {},
    'sort': null,
    'order': null,
    'filtre': "encours",
    'resume': true
  });

  const navigate = useNavigate();

  const [globalError, setGlobalError] = useState()
  const [searchParams, setSearchParams] = useSearchParams();
  const [proformas, setProformas] = useState()
  const [isGetProformasLoading, setIsGetProformasLoading] = useState()
  const [isPDFLoading, setIsPDFLoading] = useState()
  const [sideWidth, setSideWidth] = useState()
  const [tableHeaders, setTableHeaders] = useState()
  const [checkedElementIdList, setCheckedElementIdList] = useState([])
  const [currentPagination, setCurrentPagination] = useState(1)
  const [isTableFilterVisible, setIsTableFilterVisible] = useState(false)
  const [confirmDialog, setConfirmDialog] = useState({ show: false, dialogInfos: null })
  const [currentProforma, setCurrentProforma] = useState()
  const [sendMailDialog, setSendMailDialog] = useState({})

  let searchRef = useRef(null);

  const [tableRowElementActions] = useState([
    { icon: "print", title: "Imprimer", action: "downloadPDF", disableKeyValues: { 'validite_etat_calc': ['annulee'] } },
    { icon: "email", title: "Envoyer par mail", action: "sendEmail", disableKeyValues: { 'validite_etat_calc': ['annulee'] } }
  ])

  const [proformaElementActions] = useState([
    { icon: "print", title: "Imprimer", action: "downloadPDF", disableKeyValues: { 'validite_etat_calc': ['annulee'] } },
    { icon: "email", title: "Envoyer par mail", action: "sendEmail", disableKeyValues: { 'validite_etat_calc': ['annulee'] } }
  ])

  useEffect(() => {
    if (grants) {
      granted(grants, "proformas.edit") && tableRowElementActions.push({ icon: "edit", title: "Modifier la proforma (crée un brouillon)", action: "editProforma", disableKeyValues: { 'validite_etat_calc': ['annulee', 'facturee'] } })
      granted(grants, "proformas.edit") && proformaElementActions.push({ icon: "edit", title: "Modifier la proforma (crée un brouillon)", action: "editProforma", disableKeyValues: { 'validite_etat_calc': ['annulee', 'facturee'] } })

      granted(grants, "factures.edit") && tableRowElementActions.push({ icon: "task", title: "Valider en facture", action: "generateFacture", disableKeyValues: { 'validite_etat_calc': ['annulee', 'expiree', 'facturee'], 'client.type': ['comptant'] } })
      granted(grants, "factures.edit") && proformaElementActions.push({ icon: "task", title: "Valider en facture", action: "generateFacture", disableKeyValues: { 'validite_etat_calc': ['annulee', 'expiree', 'facturee'], 'client.type': ['comptant'] } })

      granted(grants, "proformas.edit") && tableRowElementActions.push({ icon: "file_copy", title: "Dupliquer (crée un brouillon)", action: "duplicateProforma" })
      granted(grants, "proformas.edit") && proformaElementActions.push({ icon: "file_copy", title: "Dupliquer (crée un brouillon)", action: "duplicateProforma" })

      granted(grants, "factures.edit") && tableRowElementActions.push({ icon: "description", title: "Convertir en brouillon de facture", action: "convertToFacture", disableKeyValues: { 'validite_etat_calc': ['expiree', 'facturee'] } })
      granted(grants, "factures.edit") && proformaElementActions.push({ icon: "description", title: "Convertir en brouillon de facture", action: "convertToFacture", disableKeyValues: { 'validite_etat_calc': ['expiree', 'facturee'] } })

      granted(grants, "factures.edit") && tableRowElementActions.push({ icon: "description", title: "Convertir en brouillon d'abonnement", action: "convertToAbonnement", disableKeyValues: { 'validite_etat_calc': ['expiree', 'facturee'] } })
      granted(grants, "factures.edit") && proformaElementActions.push({ icon: "description", title: "Convertir en brouillon d'abonnement", action: "convertToAbonnement", disableKeyValues: { 'validite_etat_calc': ['expiree', 'facturee'] } })

      granted(grants, "proformas.remove") && tableRowElementActions.push({ icon: "delete_forever", title: "Annuler", action: "removeProformaDialog", disableKeyValues: { 'validite_etat_calc': ['facturee'] } })
      granted(grants, "proformas.remove") && proformaElementActions.push({ icon: "delete_forever", title: "Annuler", action: "removeProformaDialog", disableKeyValues: { 'validite_etat_calc': ['facturee'] } })
    }
  }, [grants]);

  useEffect(() => {
    if (globalContextLoaded) {
      searchParams.get('proformaId') && getProforma(searchParams.get('proformaId'))
      setPreferences()
      getProformas()

      // Si un brouillon est en cours d'édition on redirige.
      if (!searchParams.get('factureId') && preferences.proformas.currentDraft) {
        navigate(`/${folderDetails?.dossier?._id}/proformas/brouillon?brouillonId=${preferences.proformas.currentDraft}&from=proformas`)
      }

    }
  }, [globalContextLoaded]);

  function setPreferences() {
    setTableHeaders(formatTableHeadersFromPrefs(preferences.proformas['tableHeaders'], parametres.proformas['fieldsLabel']))
    proformasParams.current['sort'] = preferences.proformas['tableSort']
    proformasParams.current['order'] = preferences.proformas['tableOrder']
    proformasParams.current['limit'] = preferences.proformas['tableCount'] || 5
    proformasParams.current['fields'] = Object.keys(preferences.proformas['tableHeaders']).join(',')
  }

  function getDayTitle(place) {
    let dateRef = proformasParams.current?.filters['filter[date]']?.find(f => f.operation == "equal_to")?.value ? new Date(proformasParams.current?.filters['filter[date]']?.find(f => f.operation == "equal_to")?.value + "T00:00:00") : new Date()
    var newDate = new Date(dateRef.getTime())
    newDate.setDate(dateRef.getDate() + place);
    var days = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
    var dayName = days[newDate.getDay()];
    return `${dayName} ${newDate.getDate()}`
  }

  function getProforma(proformaId) {
    if (granted(grants, "proformas.consult")) {

      ProformaService.getProforma(folderDetails?.dossier?._id, proformaId).then(res => {
        if (res.status == 204) {
          setGlobalError({ statusText: "La proforma demandée n'a pas été trouvée" })
        } else if (!res.data?.data) {
          setGlobalError({ statusText: res.statusText })
        } else {
          changeCurrentProforma(res.data.data)
        }
      }).catch(error => {
        setGlobalError(error)
      });
    }
  }

  function getProformas() {
    setCheckedElementIdList([])
    if (granted(grants, "proformas.consult")) {
      setIsGetProformasLoading(true)
      if (!proformasParams.current['filtre']) {
        ProformaService.getProformas(folderDetails?.dossier?._id, proformasParams.current).then(res => {
          setProformas({
            proformas: res.data.data.proformas,
            count: res.data.data.resume.total_count,
            resume: res.data.data.resume
          })
          setIsGetProformasLoading(false)
        }).catch(error => {
          setGlobalError(error)
          setIsGetProformasLoading(false)
        });
      } else {
        ProformaService.getProformasSummary(folderDetails?.dossier?._id, proformasParams.current).then(res => {
          setProformas({
            proformas: res.data.data[proformasParams.current['filtre']]?.length > 0 ? res.data.data[proformasParams.current['filtre']] : null,
            count: res.data.data.resume[proformasParams.current['filtre']].count,
            resume: res.data.data.resume
          })
          setIsGetProformasLoading(false)
        }).catch(error => {
          setGlobalError(error)
          setIsGetProformasLoading(false)
        });
      }
    }
  }

  function getProformasPDF(idList) {
    if (granted(grants, "proformas.consult")) {
      !idList && setIsPDFLoading(true)
      let params = {
        'start': 0,
        'search': proformasParams.current.search,
        'sort': proformasParams.current.sort,
        'order': proformasParams.current.order,
        'filters': proformasParams.current.filters,
        'filtre': proformasParams.current.filtre
      }

      if (idList) {
        params['proformas'] = idList
      }

      EditionService.getListe(folderDetails?.dossier?._id, params, "proformas", "pdf").then(res => {
        setIsPDFLoading(false)
        if (!res?.data) {
          setGlobalError({ statusText: res.statusText })
        } else {
          getFile(res)
        }
      }).catch(error => {
        setIsPDFLoading(false)
        setGlobalError(error)
      });
    }
  }

  function removeProformaList(proformaIdList) {
    ProformaService.removeProformas(folderDetails?.dossier?._id, proformaIdList).then(res => {
      setConfirmDialog({ show: false });
      getProformas()
      changeCurrentProforma()
      setSideWidth()
      uncheckElementList(proformaIdList)
    }).catch(err => {
      setConfirmDialog({
        ...confirmDialog,
        dialogInfos: { ...confirmDialog.dialogInfos, error: err }
      })
    });
  }

  function uncheckElementList(idList) {
    let checkedElementIdListCopy = [...checkedElementIdList];
    idList.map(id => {
      let index = checkedElementIdListCopy.indexOf(id)
      if (index >= 0) {
        checkedElementIdListCopy.splice(index, 1)
      }
    })
    setCheckedElementIdList(checkedElementIdListCopy)
  }

  function saveTableHeadersPrefs(e) {
    const newHeadersObject = {}
    e.forEach(object => {
      newHeadersObject[object['dataTarget']] = { position: object['position'], hidden: object['hidden'] }
    });
    updatePreference({ ["tableHeaders"]: newHeadersObject })
  }

  function updatePreference(prefs) {
    PreferenceService.updatePreferences(folderDetails?.dossier?._id, { prefs: { ['proformas']: prefs } }).then(res => {
      getPreferences()
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function changeCurrentProforma(proforma) {
    proforma?._id ? setSearchParams({ proformaId: proforma._id }) : setSearchParams(searchParams.delete('proformaId'))
    setCurrentProforma(proforma)
  }

  function changeTableHeaders(e) {
    setTableHeaders(e)
    saveTableHeadersPrefs(e)
  }

  function changePagination(p) {
    setCurrentPagination(p)
    proformasParams.current['start'] = (proformasParams.current.limit * p) - proformasParams.current.limit
    getProformas()
  }

  function changeLimit(l) {
    proformasParams.current['limit'] = l
    updatePreference({ ["tableCount"]: l })
    changePagination(1)
  }

  let searchTimeOut;
  function changeSearchValue(value) {
    window.clearTimeout(searchTimeOut);
    searchTimeOut = window.setTimeout(function () {
      setCurrentPagination(1)
      proformasParams.current['start'] = 0
      proformasParams.current['search'] = value ? value : ""
      searchRef.current.value = value ? value : ""
      getProformas()
    }, 1000);
  }

  let filtersTimeOut;
  function changeFilters(f) {
    window.clearTimeout(filtersTimeOut);
    filtersTimeOut = window.setTimeout(function () {
      setCurrentPagination(1)
      proformasParams.current['start'] = 0
      proformasParams.current['filters'] = f ? f : {}
      getProformas()
    }, 1000);
  }

  function clearFilters() {
    setCurrentPagination(1)
    proformasParams.current['start'] = 0
    proformasParams.current['filters'] = {}
    getProformas()
    setIsTableFilterVisible(false)
  }

  function changeTagIdList(tagIdList) {
    let filtersCopy = { ...proformasParams?.current['filters'] }
    if (tagIdList.length > 0) {

      let tagArray = []
      tagIdList.map(tagId => {
        tagArray.push(tagId)
      })

      if (!filtersCopy[`filter[client.tags._id]`]) {
        filtersCopy[`filter[client.tags._id]`] = []
      }

      filtersCopy[`filter[client.tags._id]`] = [
        {
          "operation": "equal_to",
          "operator": "=",
          "value": tagArray.toString()
        }
      ]
      changeFilters(filtersCopy)
      setIsTableFilterVisible(true)
    } else {
      if (filtersCopy && filtersCopy[`filter[client.tags._id]`]) {
        delete filtersCopy[`filter[client.tags._id]`]
        changeFilters(filtersCopy)
      }
    }
  }

  function changeSortOrder(s, o) {
    proformasParams.current['sort'] = s
    proformasParams.current['order'] = o
    updatePreference({ ["tableSort"]: s, ["tableOrder"]: o })
    getProformas()
  }

  function onProformaSaved(proformaId) {
    getProforma(proformaId)
    getProformas()
  }

  function closeSide() {
    setCurrentProforma()
  }

  function openBrouillon(brouillonId, documentType) {
    navigate(`/${folderDetails?.dossier?._id}/${documentType}/brouillon?brouillonId=${brouillonId}&from=proformas`)
  }

  function createNewProforma() {
    let newProforma = {
      "type": "proforma"
    }
    ProformaService.postProforma(folderDetails?.dossier?._id, { proformas: [newProforma] }).then(res => {
      for (var brouillonId in res.data.data.brouillons) {
        openBrouillon(brouillonId, "proformas")
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function addFilterDate(value) {
    let showDate = proformasParams.current?.filters['filter[date]']?.find(f => f.operation == "equal_to")?.value ? new Date(proformasParams.current?.filters['filter[date]']?.find(f => f.operation == "equal_to")?.value + 'T12:12:00') : new Date()
    if (value == "today") {
      showDate = new Date()
    }
    if (value == "next") {
      showDate.setDate(showDate.getDate() + 1)
    }
    if (value == "prev") {
      showDate.setDate(showDate.getDate() - 1)
    }
    setIsTableFilterVisible(true)
    if (proformasParams.current.filters) {
      proformasParams.current.filters['filter[date]'] = [{ "operation": "equal_to", "operator": "=", "value": formattedDateInput(showDate) }]
    } else {
      proformasParams.current.filters = { 'filter[date]': [{ "operation": "equal_to", "operator": "=", "value": formattedDateInput(showDate) }] }
    }
    let tableHeadersCopy = [...tableHeaders];
    tableHeadersCopy.find(t => t.dataTarget == "date").hidden = false
    setTableHeaders(tableHeadersCopy);
    setCurrentPagination(1)
    proformasParams.current['start'] = 0
    getProformas()
  }

  function removeProformaListDialog(proformaIdList) {
    setConfirmDialog({
      show: true,
      dialogInfos: {
        title: `Supprimer ${proformaIdList.length} proforma(s) ?`,
        description: 'Voulez vous supprimer les éléments sélectionnés ?',
        actionName: 'Supprimer la sélection',
        btnVariant: 'danger',
        element: proformaIdList,
        error: false,
        confirmAction: 'removeProformaList'
      }
    })
  }

  function removeProformaDialog(proforma) {
    setConfirmDialog({
      show: true,
      dialogInfos: {
        title: proforma.nom,
        description: 'Voulez vous supprimer cet élément ?',
        actionName: 'Supprimer',
        btnVariant: 'danger',
        element: [proforma._id],
        error: false,
        confirmAction: 'removeProformaList'
      }
    })
  }

  function downloadPDF(proforma) {
    EditionService.getProforma(folderDetails?.dossier?._id, proforma._id, "pdf").then(res => {
      if (!res.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        getFile(res)
      }
    }).catch(async (error) => {
      if (
        error.request.responseType === 'blob' &&
        error.response.data instanceof Blob &&
        error.response.data.type &&
        error.response.data.type.toLowerCase().indexOf('json') != -1
      ) {
        setGlobalError({ response: JSON.parse(await error.response.data.text()) })
      } else {
        setGlobalError(error)
      }
    });
  }

  function sendEmail(proforma, source) {

    // Si envoie mail à partir d'une proforma unique'
    if (proforma) {
      let params = {
        filter: {
          _id: "=" + proforma._id
        }
      }

      setSendMailDialog({
        "clientIdList": [proforma.client_id],
        "folderId": folderDetails?.dossier?._id,
        "editionUrl": "proformas",
        "params": params,
        "totalElements": 1,
        "show": true
      })
      return
    }

    // Si envoie mail à partir des filtres
    if (source == "filters") {
      let params = {
        filters: proformasParams.current.filters,
        search: proformasParams.current.search,
        filter: {},
        filtre: proformasParams.current.filtre
      }

      if (proformas?.resume?.total_count == 1) {
        params['filter']['_id'] = "=" + proformas?.proformas[0]._id
      }

      // s'il y a un filtre
      let count = proformas?.resume?.total_count
      let editionUrl = "proformas"
      if(proformasParams.current.filtre){
        editionUrl = "proformas/summary"
        count = proformas.resume[proformasParams.current.filtre].count
      }

      setSendMailDialog({
        "clientIdList": proformas?.resume?.total_count == 1 ? [proformas?.proformas[0].client_id] : null,
        "folderId": folderDetails?.dossier?._id,
        "editionUrl": editionUrl,
        "params": params,
        "totalElements": count,
        "show": true
      })
      return
    }

    // Si envoie mail à partir des éléments sélectionnés
    if (source == "checked") {
      let params = {
        filter: {
          _id: "=" + checkedElementIdList.join(',')
        }
      }

      let proformaClientIdList = proformas?.proformas.filter(f => checkedElementIdList.includes(f._id)).map(f => f.client_id)

      setSendMailDialog({
        "clientIdList": [proformaClientIdList],
        "folderId": folderDetails?.dossier?._id,
        "editionUrl": "proformas",
        "params": params,
        "totalElements": checkedElementIdList.length,
        "show": true
      })
      return
    }
  }

  function downloadCheckedProformas() {

    let params = {}
    if (checkedElementIdList?.length > 0) {
      params["filter"] = {}
      params["filter"]["_id"] = "=" + checkedElementIdList.join(',')
    }

    EditionService.getProformas(folderDetails?.dossier?._id, params).then(res => {
      if (!res.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        getFile(res)
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function editProforma(proforma) {
    ProformaService.updateProforma(folderDetails?.dossier?._id, proforma._id).then(res => {
      if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        let brouillonId = Object.keys(res.data.data.brouillons)[0]
        openBrouillon(brouillonId, "proformas")
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function convertToFacture(proforma) {
    ProformaService.convertToFacture(folderDetails?.dossier?._id, proforma._id).then(res => {
      if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        let brouillonId = Object.keys(res.data.data.brouillons)[0]
        openBrouillon(brouillonId, "factures")
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function convertToAbonnement(proforma) {
    ProformaService.convertToAbonnement(folderDetails?.dossier?._id, proforma._id).then(res => {
      if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        let brouillonId = Object.keys(res.data.data.brouillons)[0]
        openBrouillon(brouillonId, "abonnements")
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }


  function duplicateProforma(proforma) {
    ProformaService.duplicateProforma(folderDetails?.dossier?._id, proforma._id).then(res => {
      if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        let brouillonId = Object.keys(res.data.data.brouillons)[0]
        openBrouillon(brouillonId, "proformas")
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function generateFacture(proforma) {
    ProformaService.generateFacture(folderDetails?.dossier?._id, proforma._id, { 'do_not_simulate': true }).then(res => {
      if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {

        if (res.data?.data?.failed) {
          setGlobalError({ data: { data: res.data?.data?.failed, status: { message: "La génération a échouée." } } })
        }

        if (res.data?.data?.factures) {
          navigate(`/${folderDetails?.dossier?._id}/factures?factureId=${res.data?.data?.factures[proforma._id]}`)
        }

      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function changeParamFiltre(value) {
    proformasParams.current['filtre'] = value
    setCurrentPagination(1)
    proformasParams.current['start'] = 0
    getProformas()
  }

  return (
    <Container fluid id="Proformas" className="py-4">

      <div className="pb-2 d-flex align-items-center justify-content-between">
        <h4 className="m-0">Proformas</h4>
        <div>
          {/* Brouillons en cours */}
          <Brouillons brouillonTypes={["proforma"]} openBrouillon={b => openBrouillon(b, "proformas")} grantedConsult={granted(grants, "brouillons.consult")} grantedEdit={granted(grants, "brouillons.edit")} grantedRemove={granted(grants, "brouillons.remove")} />
          {granted(grants, "proformas.edit") &&
            <Button variant="primary" onClick={() => createNewProforma()}>Créer une proforma</Button>
          }
        </div>
      </div>

      <ErrorManager error={globalError} fixed="true" />

      <SendMailDialog clientIdList={sendMailDialog.clientIdList} folderId={sendMailDialog.folderId} editionUrl={sendMailDialog.editionUrl} params={sendMailDialog.params} totalElements={sendMailDialog.totalElements} show={sendMailDialog.show} setCloseModal={() => setSendMailDialog({ show: false })} />

      <ConfirmDialog
        show={confirmDialog.show}
        dialogInfos={confirmDialog.dialogInfos}
        setCancel={() => setConfirmDialog({ show: false })}
        setConfirm={(a, e) => eval(a)(e)}
      />

      <Row>
        <Col xs="12">
          {granted(grants, "proformas.consult") ?
            <>
              <Row className="mb-4 gx-2">
                <Col sm="12" md="6" lg="auto" xl="3" className="mb-2 mb-lg-0">
                  <InputGroup className="w-auto">
                    <i className="material-icons input-icon text-gray-400">search</i>
                    <FormControl
                      className="input-icon-space rounded-start"
                      placeholder="Recherche globale"
                      type="text"
                      onChange={e => changeSearchValue(e.target.value)}
                      ref={searchRef}
                    />
                    {proformasParams.current['search'] &&
                      <Button onClick={() => changeSearchValue()} variant="gray-100" className="border border-start-0">
                        <i className="material-icons i-lg">clear</i>
                      </Button>
                    }
                  </InputGroup>
                </Col>
                <Col sm="12" md="auto" xl="auto" className="d-flex mb-2 mb-xl-0">
                  <InputGroup className="me-2 w-auto">
                    <TagsFilter btnClassName="rounded-end-0" btnTitle="Filtrer par tags client" documentType="clients" changeTagIdList={tagIdList => changeTagIdList(tagIdList)} parentFilters={proformasParams?.current['filters']} />
                    {Object.keys(proformasParams.current.filters).length == 0 &&
                      <OverlayTrigger placement="right" delay={{ show: 800 }} overlay={<Tooltip>Filtres de recherche</Tooltip>}>
                        <Button variant="secondary" onClick={() => setIsTableFilterVisible(!isTableFilterVisible)}>
                          <i className="material-icons i-lg">filter_alt</i>
                        </Button>
                      </OverlayTrigger>
                    }
                    {Object.keys(proformasParams.current.filters).length != 0 &&
                      <Button className="d-flex" variant="warning" onClick={() => clearFilters()}>
                        Suppr. les filtres
                        <i className="material-icons i-lg ms-2 d-inline-flex">clear</i>
                      </Button>
                    }
                  </InputGroup>
                  <ColManager tableHeaders={tableHeaders} changeTableHeaders={e => changeTableHeaders(e)} />
                </Col>
                <Col sm="12" md="auto" xl="auto" className="d-flex mb-2 mb-xl-0">
                  <ButtonGroup className="">
                    <Button variant="secondary" onClick={() => addFilterDate("prev")}>
                      {getDayTitle(-1)}
                      <i className="material-icons float-start me-1">
                        arrow_back_ios_new
                      </i>
                    </Button>
                    <Button onClick={() => addFilterDate("today")} variant={proformasParams.current?.filters && proformasParams.current?.filters['filter[date]']?.find(f => f.operation == "equal_to")?.value == formattedDateInput(new Date()) ? "primary-200" : "secondary"} >Proformas du jour</Button>
                    <Button variant="secondary" onClick={() => addFilterDate("next")}>
                      {getDayTitle(1)}
                      <i className="material-icons float-end ms-1">
                        arrow_forward_ios
                      </i>
                    </Button>
                  </ButtonGroup>
                </Col>

                <Col sm="12" md="auto" xl="auto" className="">

                  {proformas?.count > 0 &&
                    <Dropdown className="d-inline-block me-2">
                      <Dropdown.Toggle variant="secondary" id="dropdown-selectionnes">
                        {proformas?.count} Résultat{proformas?.count > 1 && <span>s</span>}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => getProformasPDF()}>Imprimer la liste</Dropdown.Item>
                        {/* <Dropdown.Item onClick={() => getProformasPDF()}>Imprimer les factures</Dropdown.Item> */}
                        <Dropdown.Item onClick={() => sendEmail(null, "filters")}>Envoyer les proformas par mail</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  }

                  {checkedElementIdList?.length > 0 &&
                    <Dropdown className="d-inline-block me-2">
                      <Dropdown.Toggle variant="dark" id="dropdown-selectionnes">
                        {checkedElementIdList.length} Sélectionné{checkedElementIdList?.length > 1 && <span>s</span>}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => getProformasPDF(checkedElementIdList)}>Imprimer la liste</Dropdown.Item>
                        <Dropdown.Item onClick={() => downloadCheckedProformas()}>Imprimer les proformas</Dropdown.Item>
                        <Dropdown.Item onClick={() => sendEmail(null, "checked")}>Envoyer les proformas par mail</Dropdown.Item>
                        {granted(grants, "proformas.remove") &&
                          <>
                            <Dropdown.Divider />
                            <Dropdown.Item className="text-danger" onClick={() => removeProformaListDialog(checkedElementIdList)}>Supprimer</Dropdown.Item>
                          </>
                        }
                      </Dropdown.Menu>
                    </Dropdown>
                  }
                </Col>

                {/* <Col sm="12" md="auto" xl="auto" className="">
                  <Button disabled={isPDFLoading} variant="secondary" className="me-2" onClick={() => getProformasPDF()}>
                    {!isPDFLoading && <i className="material-icons i-lg float-start me-2">print</i>}
                    {isPDFLoading && <Spinner animation="border" size="sm" className="me-2" />}
                    Imprimer la liste <span className="badge rounded-pill text-bg-light">{proformas?.count}</span>
                  </Button>

                  {checkedElementIdList?.length > 0 &&
                    <Dropdown className="d-inline-block me-2">
                      <Dropdown.Toggle variant="dark" id="dropdown-selectionnes">
                        {checkedElementIdList.length} Sélectionné{checkedElementIdList?.length > 1 && <span>s</span>}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => downloadCheckedProformas()}>Imprimer les proformas</Dropdown.Item>

                        {granted(grants, "proformas.remove") &&
                          <>
                            <Dropdown.Item onClick={() => getProformasPDF(checkedElementIdList)}>Imprimer la liste sélectionnée</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item className="text-danger" onClick={() => removeProformaListDialog(checkedElementIdList)}>Supprimer</Dropdown.Item>
                          </>
                        }
                      </Dropdown.Menu>
                    </Dropdown>
                  }
                </Col> */}

              </Row>
              <Row className="mb-3">
                <Col>
                  <Nav variant="pills" activeKey={proformasParams.current.filtre || "all"} >
                    <Nav.Item>
                      <Nav.Link onClick={() => changeParamFiltre('encours')} eventKey="encours" className="border d-flex flex-column me-2 h-100">
                        <span className="fw-bold">En cours ({proformas?.resume?.encours?.count})</span>
                        {proformas?.resume?.encours?.total_ttc != null &&
                          <span className="">
                            Total TTC : {currencyFormat(proformas?.resume?.encours?.total_ttc)}
                          </span>
                        }
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link onClick={() => changeParamFiltre('expirees')} eventKey="expirees" className="border d-flex flex-column me-2 h-100">
                        <span className="fw-bold">Expirées ({proformas?.resume?.expirees?.count})</span>
                        {proformas?.resume?.expirees?.total_ttc != null &&
                          <span className="">
                            Total TTC : {currencyFormat(proformas?.resume?.expirees?.total_ttc)}
                          </span>
                        }
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link onClick={() => changeParamFiltre('facturees')} eventKey="facturees" className="border d-flex flex-column me-2 h-100">
                        <span className="fw-bold">Facturées ({proformas?.resume?.facturees?.count})</span>
                        {proformas?.resume?.facturees?.total_ttc != null &&
                          <span className="">
                            Total TTC : {currencyFormat(proformas?.resume?.facturees?.total_ttc)}
                          </span>
                        }
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link onClick={() => changeParamFiltre('annulees')} eventKey="annulees" className="border d-flex flex-column me-2 h-100">
                        <span className="fw-bold">Annulées ({proformas?.resume?.annulees?.count})</span>
                        {proformas?.resume?.annulees?.total_ttc != null &&
                          <span className="">
                            Total TTC : {currencyFormat(proformas?.resume?.annulees?.total_ttc)}
                          </span>
                        }
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link onClick={() => changeParamFiltre()} eventKey="all" className="border d-flex flex-column me-2 h-100">
                        <span className="fw-bold">Toutes ({proformas?.resume?.total_count})</span>
                        <span className="">
                          Total TTC : N/C
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <div className="bg-white rounded border">
                    <DynamicTable
                      isDataLoading={isGetProformasLoading}
                      elementActions={tableRowElementActions}
                      setElementAction={(a, e) => eval(a)(e)}
                      sideWidth={sideWidth}
                      tableHeaders={tableHeaders}
                      tableDataList={proformas?.proformas}
                      currentElement={currentProforma}
                      changeCurrentElement={e => changeCurrentProforma(e)}
                      checkedElementIdList={checkedElementIdList}
                      setCheckedElementIdList={e => setCheckedElementIdList(e)}
                      changeFilters={f => changeFilters(f)}
                      isTableFilterVisible={isTableFilterVisible}
                      changeSortOrder={(s, o) => changeSortOrder(s, o)}
                      params={proformasParams.current}
                    />
                    <Pagination className="m-3" itemsLength={proformas?.count} elementsPerPage={proformasParams.current.limit} currentPagination={currentPagination} changePagination={p => changePagination(p)} showChangeLimit showDefinePage changeLimit={l => changeLimit(l)} />
                  </div>
                </Col>
              </Row>
            </>
            :
            <Row>
              <Col>
                <em className="py-1 px-2 bg-gray-100 rounded mt-2">- Vous n'avez pas les droits d'accès à cette ressource -</em>
              </Col>
            </Row>
          }

          {(granted(grants, "proformas.consult") && currentProforma) &&
            <SideDetails
              currentElement={{ id: currentProforma?._id, label: new Date(currentProforma?.date).toLocaleString(), title: currentProforma?.client_nom }}
              changeCurrentElement={e => changeCurrentProforma(e)}
              setSideClose={closeSide}
              setSideWidth={e => setSideWidth(e)}
              detailsComponent={
                <ProformaDetails folderId={folderDetails?.dossier?._id} proformaId={currentProforma._id} elementActions={proformaElementActions} setElementAction={(a, e) => eval(a)(e)} />
              }
            />
          }
        </Col>
      </Row>

    </Container>


  );
}

export default Proformas;